<template>
  <section id="home" class="home-section">
    <BackgroundImage
      :src="backgroundImgBgSmokeHeader"
      class="home-section__upper"
    >
      <div id="about" class="pad-section container">
        <div class="topHeader row">
          <h1 class="blurySmokeHeadlineH1 wow fadeInLeft col-sm-12 text-center">
            {{ $t("surgical_smoke") }}
          </h1>
        </div>
      </div>
    </BackgroundImage>
    <div class="row home__video-container">
      <WrappedVideo
        name="health_hazard"
        :poster="videoPoster"
        style="height: calc(100vw * 0.5625);"
      />
    </div>
    <div
      class="home-section__lower parallax iparaxify paraxify container-fluid text-center pl-0 pr-0"
    >
      <div class="container text-center">
        <h2
          class="smokeheadlineh2 healthHazardHeadline wow fadeInUp"
          v-html="$t('health_hazard')"
        ></h2>
      </div>
      <SmokeInducedSickness />
      <GenmanipulatedSubstances />
    </div>
  </section>
</template>

<script>
import GenmanipulatedSubstances from "./GenmanipulatedSubstances";
import SmokeInducedSickness from "./SmokeInducedSickness";
import BackgroundImage from "@/components/BackgroundImage";
import WrappedVideo from "@/components/WrappedVideo";
import { languageAdapter } from "@/services/languageAdapter";
import { createVimeoMetadataUrl } from "@/services/urlBuilder.js";

export default {
  name: "HomeSection",
  components: {
    GenmanipulatedSubstances,
    SmokeInducedSickness,
    BackgroundImage,
    WrappedVideo
  },
  data() {
    return {
      videoToShow: "",
      videoClicked: false
    };
  },
  computed: {
    videoPoster() {
      return this.$store.getters.image_main_video_preview;
    },
    backgroundImgBgSmokeHeader() {
      return this.$store.getters.image_bg_smoke_header;
    }
  },
  methods: {
    clickedOnVideo() {
      this.videoClicked = true;
    }
  }
};
</script>

<style scoped>
#home {
  margin-top: -90px;
}
.videoStyle {
  height: 100%;
  width: 100%;
  border: 0;
  object-fit: cover;
}
.videoStyleIframe {
  height: 100%;
  width: 100%;
  border: 0;
}
.home-section__upper {
  padding-bottom: 8px;
}
.healthHazardHeadline {
  padding-top: 80px;
  color: white;
  margin-bottom: 50px;
  letter-spacing: 6px;
}

.topHeader {
  padding-top: 80px;
}
.home__video-container {
  position: relative;
}
.home__video-container .videoComponent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
}
.home__video-container .videoComponent img.videoComponent__poster {
  max-width: auto;
  height: auto;
}
.parallax {
  width: 100%;
  background: url(../../assets/images/bg_smoke_new.jpg) no-repeat center center;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.paraxify {
  background-attachment: fixed;
  background-position: center center;
  background-size: cover;
}
</style>
